export default __webpack_public_path__ + "static/media/not_foundPage.bba478a4.svg";